/**
 * ResponsiveSupervisor — Wrapper for the /supervisor dashboard route.
 * Uses SupervisorLayout which handles mobile/desktop switching.
 */
import React from 'react';
import SupervisorLayout from './SupervisorLayout';
import SupervisorDashboard from '../pages/Supervisor/SupervisorDashboard';
import { useLanguage } from '../i18n/LanguageContext';
import { usePageTitle } from '../contexts/PageTitleContext';

const ResponsiveSupervisor: React.FC = () => {
  const { t } = useLanguage();
  usePageTitle(t('supervisor.dashboard'), t('nav.dashboard'));

  return (
    <SupervisorLayout>
      <SupervisorDashboard />
    </SupervisorLayout>
  );
};

export default ResponsiveSupervisor;
